// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#mf .ant-btn {\n  display: inline-block;\n  height: 25px;\n  font-size: 10px;\n  padding: 0px 5px 0 5px;\n  border-radius: 5px;\n  line-height: 25px;\n}\n.ant-card-head-wrapper {\n  margin-top: 10px;\n}\n@media screen and (max-width: 450px) {\n  .ant-card-head-title {\n    max-width: none;\n  }\n}\n", ""]);
// Exports
module.exports = exports;
